var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1979 15.8501L9.76042 1.31672C9.34375 0.500057 8.65833 0.500057 8.23958 1.31672L0.802082 15.8501C0.383332 16.6667 0.791665 17.3334 1.70833 17.3334H16.2917C17.2083 17.3334 17.6167 16.6667 17.1979 15.8501ZM8.16666 6.08339C8.16666 5.62315 8.53976 5.25006 9 5.25006C9.46024 5.25006 9.83333 5.62315 9.83333 6.08339V11.9167C9.83333 12.377 9.46024 12.7501 9 12.7501C8.53976 12.7501 8.16666 12.377 8.16666 11.9167V6.08339ZM9 15.6667C8.4247 15.6667 7.95833 15.2004 7.95833 14.6251C7.95833 14.0498 8.4247 13.5834 9 13.5834C9.57529 13.5834 10.0417 14.0498 10.0417 14.6251C10.0417 15.2004 9.57529 15.6667 9 15.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionSign);
export default __webpack_public_path__ + "static/media/attention-sign.99b33950a5a0d0fc50161b594b197060.svg";
export { ForwardRef as ReactComponent };